/**
 * Rental Product Detector and Transformer
 * 
 * This script detects if the current product is a rental item
 * and transforms the standard product page into a rental page.
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Rental detector script initialized');
  
  // Check if this is a product page
  if (!document.querySelector('.product')) {
    return;
  }
  
  // Detect if product is a rental
  const productTitle = document.querySelector('.product__title, h1.title')?.textContent || '';
  const isRental = 
    productTitle.toLowerCase().includes('rental') ||
    Array.from(document.querySelectorAll('.product-tag')).some(tag => tag.textContent.toLowerCase().includes('rental'));
  
  console.log('Product detected:', productTitle, 'Is rental:', isRental);
  
  if (!isRental) {
    return;
  }
  
  console.log('Rental product detected, transforming UI');
  
  // Add rental badge
  const productInfo = document.querySelector('.product__info-wrapper, .product-single__meta');
  if (productInfo) {
    const rentalBadge = document.createElement('div');
    rentalBadge.className = 'rental-badge';
    rentalBadge.textContent = 'Rental';
    rentalBadge.style.cssText = 'background-color: #000; color: white; display: inline-block; padding: 5px 10px; font-weight: bold; margin-bottom: 10px;';
    productInfo.prepend(rentalBadge);
  }
  
  // Transform Add to Cart button to Rent This Item
  const addToCartButton = document.querySelector('[data-add-to-cart], [name="add"]');
  if (addToCartButton) {
    addToCartButton.textContent = 'Rent This Item';
    
    // Add rental item property to the form
    const productForm = addToCartButton.closest('form[action*="/cart/add"]');
    if (productForm) {
      const rentalItemInput = document.createElement('input');
      rentalItemInput.type = 'hidden';
      rentalItemInput.name = 'properties[Rental Item]';
      rentalItemInput.value = 'Yes';
      productForm.appendChild(rentalItemInput);
      
      // Add return date calculation
      const variantRadios = document.querySelectorAll('input[name="id"], select[name="id"]');
      const quantityInput = document.querySelector('input[name="quantity"]');
      
      if (variantRadios.length && quantityInput) {
        // Add delivery date field
        const deliveryDateContainer = document.createElement('div');
        deliveryDateContainer.className = 'rental-field';
        deliveryDateContainer.style.cssText = 'margin: 15px 0;';
        
        const deliveryDateLabel = document.createElement('label');
        deliveryDateLabel.htmlFor = 'preferred_delivery_date';
        deliveryDateLabel.textContent = 'Preferred Delivery Date:';
        deliveryDateLabel.style.cssText = 'display: block; margin-bottom: 5px;';
        
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        
        const deliveryDateInput = document.createElement('input');
        deliveryDateInput.type = 'date';
        deliveryDateInput.id = 'preferred_delivery_date';
        deliveryDateInput.name = 'properties[Delivery Date]';
        deliveryDateInput.min = formattedDate;
        deliveryDateInput.value = formattedDate;
        deliveryDateInput.required = true;
        deliveryDateInput.style.cssText = 'width: 100%; padding: 8px; border: 1px solid #ddd;';
        
        deliveryDateContainer.appendChild(deliveryDateLabel);
        deliveryDateContainer.appendChild(deliveryDateInput);
        
        // Add return date display
        const returnDateContainer = document.createElement('div');
        returnDateContainer.className = 'return-date-container';
        returnDateContainer.style.cssText = 'margin: 15px 0; padding: 10px; background-color: #f3f3f3; display: none;';
        
        const returnDateText = document.createElement('p');
        returnDateText.innerHTML = '<strong>Estimated Return Date:</strong> <span id="return-date-display"></span>';
        
        const noteText = document.createElement('p');
        noteText.className = 'note';
        noteText.textContent = '* Returns are not accepted on Sundays';
        noteText.style.cssText = 'font-size: 0.8rem; color: #666; margin-top: 5px;';
        
        returnDateContainer.appendChild(returnDateText);
        returnDateContainer.appendChild(noteText);
        
        // Insert fields before the Add to Cart button
        const buttonContainer = addToCartButton.parentNode;
        buttonContainer.parentNode.insertBefore(deliveryDateContainer, buttonContainer);
        buttonContainer.parentNode.insertBefore(returnDateContainer, buttonContainer);
        
        // Update the return date when options change
        const updateReturnDate = function() {
          let duration = '';
          let variantId = '';
          
          // Get the selected variant (radio or select)
          if (variantRadios[0].tagName === 'SELECT') {
            const selectElement = variantRadios[0];
            variantId = selectElement.value;
            
            // Try to determine duration from variant title
            const selectedOption = selectElement.options[selectElement.selectedIndex];
            const variantTitle = selectedOption.textContent;
            
            if (variantTitle.toLowerCase().includes('weekly') || variantTitle.toLowerCase().includes('week')) {
              duration = 'Weekly';
            } else if (variantTitle.toLowerCase().includes('monthly') || variantTitle.toLowerCase().includes('month')) {
              duration = 'Monthly';
            }
          } else {
            // Radio buttons
            const selectedRadio = Array.from(variantRadios).find(radio => radio.checked);
            if (selectedRadio) {
              variantId = selectedRadio.value;
              duration = selectedRadio.getAttribute('data-duration') || selectedRadio.getAttribute('value-data-duration') || '';
              
              if (!duration) {
                // Try to determine from radio label
                const label = document.querySelector(`label[for="${selectedRadio.id}"]`);
                if (label) {
                  const labelText = label.textContent.toLowerCase();
                  if (labelText.includes('weekly') || labelText.includes('week')) {
                    duration = 'Weekly';
                  } else if (labelText.includes('monthly') || labelText.includes('month')) {
                    duration = 'Monthly';
                  }
                }
              }
            }
          }
          
          const deliveryDate = deliveryDateInput.value;
          const qty = parseInt(quantityInput.value) || 1;
          
          if (deliveryDate && duration) {
            const returnDate = calculateReturnDate(deliveryDate, duration, qty);
            document.getElementById('return-date-display').textContent = formatDate(returnDate);
            returnDateContainer.style.display = 'block';
            
            // Add return date to form
            let returnDateInput = document.querySelector('input[name="properties[Return Due Date]"]');
            if (!returnDateInput) {
              returnDateInput = document.createElement('input');
              returnDateInput.type = 'hidden';
              returnDateInput.name = 'properties[Return Due Date]';
              productForm.appendChild(returnDateInput);
            }
            returnDateInput.value = formatDate(returnDate);
            
            // Add duration to form
            let durationInput = document.querySelector('input[name="properties[Duration Type]"]');
            if (!durationInput) {
              durationInput = document.createElement('input');
              durationInput.type = 'hidden';
              durationInput.name = 'properties[Duration Type]';
              productForm.appendChild(durationInput);
            }
            durationInput.value = duration;
          } else {
            returnDateContainer.style.display = 'none';
          }
        };
        
        // Add event listeners
        deliveryDateInput.addEventListener('change', updateReturnDate);
        quantityInput.addEventListener('change', updateReturnDate);
        
        variantRadios.forEach(radio => {
          radio.addEventListener('change', updateReturnDate);
        });
        
        // Initial update
        updateReturnDate();
      }
    }
  }
});

/**
 * Calculate the return date based on delivery date and rental duration
 * 
 * @param {string} deliveryDate - The preferred delivery date (YYYY-MM-DD)
 * @param {string} duration - The rental duration
 * @param {number} qty - The quantity representing number of weeks/months
 * @returns {Date} - JavaScript Date object of the calculated return date
 */
function calculateReturnDate(deliveryDate, duration, qty = 1) {
  // Parse the delivery date
  const startDate = new Date(deliveryDate);
  let returnDate = new Date(startDate);
  
  // Add days based on duration
  console.log("Calculating return date for: ", {duration, qty});
  
  switch(duration) {
    case 'Weekly':
      // 7 days per week
      returnDate.setDate(startDate.getDate() + (7 * qty));
      break;
    case 'Monthly':
      // 28 days per month
      returnDate.setDate(startDate.getDate() + (28 * qty));
      break;
    default:
      // Default to weekly if unknown
      returnDate.setDate(startDate.getDate() + (7 * qty));
  }
  
  // Check if return date falls on a Sunday (store closed)
  // If so, move to Monday
  if (returnDate.getDay() === 0) { // 0 = Sunday
    returnDate.setDate(returnDate.getDate() + 1);
  }
  
  return returnDate;
}

/**
 * Format a JavaScript Date object to a user-friendly string
 * 
 * @param {Date} date - JavaScript Date object
 * @returns {string} - Formatted date string (e.g., "May 20, 2025")
 */
function formatDate(date) {
  return date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
}
